/**
 * Controller: membershipCategoriesCreatePricing
 */
angular.module('acme.view.application.membership.categories.create.pricing.controllers', [
    'acme.common.service.membership',
    'acme.common.service.helpers',
    'acme.common.factory.notice',
    'acme.common.service.validate'
  ])
  .controller('MembershipCategoriesCreatePricingController', [ '$scope', '$state', 'MembershipService', 'HelpersService', 'NoticeFactory', 'ValidateService', function($scope, $state, MembershipService, HelpersService, NoticeFactory, ValidateService) {

    $scope.membershipCategoriesCreatePricing = {

      model: {},

      isSubmitted: false,

      validators: [],

      notice: new NoticeFactory(),

      init: function() {
        this.model = MembershipService.getModel();

        $scope.$on('MembershipService::Update', this.onMembershipServiceUpdate);
        $scope.$on('MembershipCategoriesCreate::Update', this.onMembershipCategoryCreateUpdate);
        $scope.$on('MembershipCategoriesCreate::Save', this.onMembershipCategoryCreateSave);

        if($state.params.id) {
          this.validators = [
            {
              field: 'membership-categories-create-pricing-price-min',
              greater: {
                message: 'Please enter a number greater than 0',
                test: function () {
                  return {
                    greater: ($scope.membershipCategoriesCreatePricing.model.price) ? HelpersService.currencyFloatToInteger($scope.membershipCategoriesCreatePricing.model.price) : 0,
                    less: 0,
                    equalTo: false
                  };
                }
              }
            },
            {
              field: 'membership-categories-create-pricing-duration-min',
              greater: {
                message: 'Please enter a number greater than 0',
                test: function () {
                  return {
                    greater: ($scope.membershipCategoriesCreatePricing.model.durationInMonths) ? $scope.membershipCategoriesCreatePricing.model.durationInMonths : 0,
                    less: 0,
                    equalTo: false
                  };
                }
              }
            }];

          ValidateService.addFieldTests(this.validators);
        }
      },

      isValid: function(field) {
        var r = true;

        if (this.isSubmitted) {
          r = ValidateService.check(this.validators, field);
        }
        return r;
      },

      getErrors: function(fieldName) {
        return ValidateService.getError(fieldName);
      },

      save: function() {

        this.notice.hideErrorMessages();
        this.notice.hideSuccessMessages();

        this.model.price = parseFloat(this.model.price);

        MembershipService.setModel(this.model);

        this.isSubmitted = true;
        ValidateService.validate(this.validators);
      },

      success: {
        init: function(response) {}
      },
      error: {
        init: function(response) {}
      },

      onMembershipServiceUpdate: function(e, data) {
        //the parent model has changed
        $scope.membershipCategoriesCreatePricing.model = MembershipService.getModel();
      },

      onMembershipCategoryCreateUpdate: function(e, data) {
        // a tab has changed
        var self = $scope.membershipCategoriesCreatePricing;

        if (data.view === 'pricing') {
          self.onMembershipServiceUpdate();
        }
      },

      onMembershipCategoryCreateSave: function(e, data) {
        $scope.membershipCategoriesCreatePricing.save();
      }

    };

    $scope.membershipCategoriesCreatePricing.init();

  }]);